module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-72x72-2160680f0d93724a12d4c67727dc93ca.png";